import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { vsOpsApi } from "./api";

const NAV_ITEMS = [
  { to: "/vs-ops/sales", label: "Продажи", shortLabel: "Продажи" },
  { to: "/vs-ops/warehouse", label: "Склад", shortLabel: "Склад" },
  {
    to: "/vs-ops/stats",
    label: "Обороты и прибыль",
    shortLabel: "Обороты",
  },
  { to: "/vs-ops/referrals", label: "Рефералка", shortLabel: "Рефералка" },
  { to: "/vs-ops/settings", label: "Настройки", shortLabel: "Настройки" },
];

function VsOpsLayout({ children, title }) {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await vsOpsApi.logout();
    } catch {
      /* ignore */
    }
    navigate("/vs-ops/login", { replace: true });
  };

  return (
    <div className="vs-ops-page">
      <header className="vs-ops-header">
        <div className="vs-ops-header-inner">
          <div className="vs-ops-header-top">
            <Link to="/vs-ops/sales" className="vs-ops-brand">
              Visoria Ops
            </Link>
            <button
              type="button"
              className="vs-ops-logout"
              onClick={handleLogout}
            >
              Выйти
            </button>
          </div>
          <button
            type="button"
            className="vs-ops-menu-toggle"
            aria-expanded={navOpen}
            aria-controls="vs-ops-nav"
            onClick={() => setNavOpen((current) => !current)}
          >
            {navOpen ? "Закрыть меню" : "Меню"}
          </button>
          <nav
            id="vs-ops-nav"
            className={`vs-ops-nav${navOpen ? " vs-ops-nav-open" : ""}`}
          >
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setNavOpen(false)}
              >
                <span className="vs-ops-nav-label-full">{item.label}</span>
                <span className="vs-ops-nav-label-short">{item.shortLabel}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <main className="vs-ops-main">
        {title ? <h1 className="vs-ops-title">{title}</h1> : null}
        {children}
      </main>
    </div>
  );
}

export default VsOpsLayout;
